import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from '../buttons';
import Modal from '../Modal';
import { Diary } from '../icons';
import Section from '../edu/Section';
import DiaryEntryView from './DiaryEntryView';
import DiaryEntryCreateContainer from '../../containers/DiaryEntryCreateContainer';
import { lockDiary } from '../../actions/auth';
import LoadingSpinner from '../LoadingSpinner';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

import './DiaryView.scss';

const DiaryView = ({ 
  firstName, 
  entries = [], 
  loading, 
  error = null 
}) => {
  const dispatch = useDispatch();
  const [createDiaryEntryOpen, setCreateDiaryEntryOpen] = useState(false);

  const openCreateDiaryEntry = () => setCreateDiaryEntryOpen(true);
  const closeCreateDiaryEntry = () => setCreateDiaryEntryOpen(false);

  // 2. Simplified Redux cleanup logic on component unmount
  useEffect(() => {
    return () => {
      dispatch(lockDiary());
    };
  }, [dispatch]);

  // Early returns for data states
  if (loading) {
    return <LoadingSpinner size="large" colorScheme="blue" />;
  }

  if (error) {
    return <ErrorMessage />;
  }

  return (
    <div>
      <div className="page-header diary__page-header">
        <h1>{`${firstName}'s Diary`}</h1>
        
        <Modal
          isOpen={createDiaryEntryOpen}
          onRequestClose={closeCreateDiaryEntry}
        >
          <DiaryEntryCreateContainer
            onDiaryEntryCreated={closeCreateDiaryEntry}
          />
        </Modal>
        
        {/* 3. Explicitly typed as "button" */}
        <Button onClick={openCreateDiaryEntry} type="button">
          Add an Entry
        </Button>
      </div>

      <Section colorScheme="red">
        {entries?.length > 0 ? (
          <div className="diary-view__container">
            {entries.map((entry) => (
              <DiaryEntryView key={entry.id} entry={entry} />
            ))}
          </div>
        ) : (
          <div className="diary-view__no-entries">
            <Diary viewBox="0 0 32 32" />
            <div className="diary-view__no-entries-text">
              You do not have any entries yet. <br /> Add your first one.
            </div>
          </div>
        )}
      </Section>
    </div>
  );
};

// 4. Cleaned up propTypes
DiaryView.propTypes = {
  firstName: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      content: PropTypes.string,
      feeling: PropTypes.string,
      hidden: PropTypes.bool
    })
  ),
  loading: PropTypes.bool.isRequired,
  error: PropTypes.shape({})
};

export default DiaryView;
